
/*========================================================================
 * $Id: sourceinfo.js 190392 2018-08-13 09:44:51Z daniel.eppensteiner $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

Mindbreeze.define('api/v2/sourceinfo',[
    "i18n/i18n",
    "api/v2/common",
    "backbone",
    "underscore",
    "model/readonlytree",
    "service/stub",
    "service/factory",
    "utils/clone"
  ], function(
    i18n,
    Common,
    Backbone,
    _,
    ReadOnlyTreeModel,
    Stub,
    ServiceFactory,
    clone
  ) {
  var SourceInfo = {};

  var SourceInfoResponse = SourceInfo.SourceInfoResponse = {      
    parseResult: function (result) {
      result = _.clone(result);
      result.properties = Common.Properties.parse({}, result.properties);
      return result;        
    },
    
    parse: function (response, options) {
      var result = {};

      options = _.extend({}, options, { response: response });

      result.sources = SourceInfoResponse.parseSources(response.sources, options);
      result.status_messages = Common.StatusMessages.parse(response.status_messages);
      result.user_name = SourceInfoResponse.parseUserName(response.user_name, options);
      result.is_anonymous_user = SourceInfoResponse.parseAnonymousUser(response.is_anonymous_user, options);

      return result;
    },

    parseAnonymousUser: function (is_anonymous_user, options) {
      if (!_.isUndefined(is_anonymous_user)) return is_anonymous_user;
    },

    parseUserName: function(user_name, options) {
      if (user_name) return user_name;
    },

    parseSources: function (sources, options) {
      var result = {};

      for (var name in sources) {
        if (!sources.hasOwnProperty(name)) {
          continue;
        }
         var sourcesProperty = sources[name];
         if (name == "sources") {
           result.sources = _.reduce(sourcesProperty, function (sources, source) {
             sources[source.id] = SourceInfoResponse.parseSource(source, options);
             return sources;
           }, {});
         } else if (name == "data_sources") {
           result.data_sources = SourceInfoResponse.parseDataSources(sourcesProperty, options);
         } else if (name == "constraints") {
           result.constraints = SourceInfoResponse.parseConstraints(sourcesProperty, options);
         } else {
           result[name] = sources[name];
         }
       }

       SourceInfoResponse.appendDataSourcesToSources(result);
       SourceInfoResponse.appendConstraintsToDataSources(result);

       return result;
     },

     appendDataSourcesToSources: function (sources) {
       _.each(sources.data_sources, function (dataSource) {
         _.each(dataSource.source_ids, function (source_id) {
           var source = sources.sources[source_id];

           if (source) {
             source.data_sources = source.data_sources || {};
             source.data_sources[dataSource.name] = clone(dataSource);
           }
         });
       });
     },
    
     appendConstraintsToDataSources: function (sources) {
       _.each(sources.constraints, function (constraint) {
         _.each(constraint.data_source_ids, function (data_source_id) {
           _.each(sources.data_sources, function (dataSource) {
             if (_.find(dataSource.ids, function (id) { return id === data_source_id; })) {
               dataSource.constraints = dataSource.constraints || {};
               dataSource.constraints[constraint.name] = clone(constraint);
             }
           });
         });
       });
     },

     parseDataSources: function (dataSources, options) {
       options = options || {}
       var result = _.reduce(dataSources, function (dataSources, source) {
         dataSources[source.name] = SourceInfoResponse.parseDataSource(source, options);
         return dataSources;
       }, {});
     
       result = SourceInfoResponse.sortDataSources(result, options);

       return result;
     },
    
     parseConstraints: function (constraints, options) {
       var result = _.reduce(constraints, function (constraints, constraint) {
         constraints[constraint.name] = SourceInfoResponse.parseConstraint(constraint, options);
         return constraints;
       }, {});

       return result;
     },

     parseSource: function (source, options) {
       delete source.data_sources; // clear data sources, they are sent in the outer Sources message
       return source;
     },
     
     parseDataSource: function (source, options) {
       options = options || {};
       delete source.constraints;
       source.query_expr.id = source.query_expr.id || "datasource_" + source.name;
       source.categories = _.map(source.categories, SourceInfoResponse.parseCategory, options);
       if (options.source_id) source.source_ids = [ options.source_id ];
       return source;
     },

     parseCategory: function (category) {
       // use name as id for old services
       if (typeof category.id === "undefined") {
         category.id = category.name;
       }
       return category;
     },

     parseConstraint: function (constraint, options) {
       options = options || {};
       // TODO: bug in api
       constraint.html = constraint.html.replace(/"https?:\/\/[^"]*\/http/i, "\"http");
       constraint.query_expr.id = constraint.query_expr.id || "constraint_" + constraint.name;
       if (options.source_id) constraint.source_ids = [ options.source_id ];

       return constraint;
     },

     mergeDataSource: function (lhs, rhs) {
       if (!lhs) return rhs;
       if (!rhs) return lhs;
       
       var merged = _.clone(lhs);

       // merged.html = rhs.html ? rhs.html : merged.html;
       merged.ids = SourceInfoResponse.mergeArrays(merged.ids, rhs.ids);
       merged.category = SourceInfoResponse.mergeArrays(merged.category, rhs.category);
       if (JSON.stringify(merged.query_expr) != JSON.stringify(rhs.query_expr)) {
         merged.query_expr = SourceInfoResponse.or(merged.query_expr, rhs.query_expr);
       }
       merged.source_ids = SourceInfoResponse.mergeArrays(merged.source_ids, rhs.source_ids);

       return merged;
     },

     or: function () {
       var queryExprs = _.reduce(arguments, function (result, queryExpr) {
         if (queryExpr) result.push(queryExpr);
         return result;
       }, []);

       if (queryExprs.length > 1) return {or: queryExprs, id: _.pluck(queryExprs, "id").sort().join(",")};
       if (queryExprs.length > 0) return queryExprs[0];
       return;
     },

     mergeArrays: function () {
       return _.reduce(arguments, function (result, arr) {
         if (arr) result = result.concat(arr);
         return result;
       }, []);
     },

     getDataSourceOrderby: function (response) {
       var data_source_orderby,
           data_source_orderby_mismatch;

       _.forEach(response.sources.data_sources, function (data_source) {
           _.forEach(data_source.source_ids, function (source_id) {
               var source = response.sources[source_id];
               if (source) {
                 if (!data_source_orderby) {
                   data_source_orderby = source.data_source_orderby;
                 } else if (data_source_orderby !== source.data_source_orderby) {
                   data_source_orderby_mismatch = true;
                 }
               }
           });
       });

       if (data_source_orderby_mismatch) {
         return undefined;
       }

       return data_source_orderby;
     },

     // options must contain response
     sortDataSources: function (data_sources, options) {
       return Common.sortByCriteria(data_sources, {
           applyCustomOrder: options.applyCustomOrder || SourceInfo.applyCustomOrder,
           criteria: "PROPERTY",
           criteriaPropertyName: SourceInfoResponse.getDataSourceOrderby(options.response) || "name",
           mapKeyPropertyName: "name"
       });
     }

  }
  SourceInfoResponse.mergeConstraint = SourceInfoResponse.mergeDataSource;
  
  var SourceInfoServiceStub = SourceInfo.SourceInfoServiceStub = Stub.extend({
    path: "sourceinfo",

    call: function(channel, request, responseObserver) {
      return Stub.prototype.call.apply(this, [channel, request, responseObserver]);
    }
  });
  
  var SourceInfoOutputModel = SourceInfo.SourceInfoOutputModel = ReadOnlyTreeModel.extend({

    initialize: function (options) {
      this.channel = options.channel;
      this.serviceStub = options.serviceStub;
    },

    parse: function (response, options) {
      response = _.clone(response);
      response = SourceInfo.SourceInfoResponse.parse(response, options);
      return response;
    },


    _mergeObjects: function(objs, mergeFunction) {
      var objs = _.filter(objs, _.isObject);
      return _.reduce(objs, function(result, obj, idx) {
        return _.reduce(obj, function(result, obj, name) {
          if (!result[name]) result[name] = obj;
          else result[name] = mergeFunction(result[name], obj);
          return result;
        }, result);
      }, {});
    },

    merge: function (lhs, rhs, options) {

      var merged = _.clone(lhs);
      options = _.extend({}, options, { response: merged });
      if (!lhs.sources) {
        merged = rhs;
      } else {
        merged.sources = _.clone(merged.sources);
        merged.sources.sources = this._mergeObjects([merged.sources.sources, rhs.sources.sources], function (v) { return v; });

        merged.sources.data_sources = this._mergeObjects([merged.sources.data_sources, rhs.sources.data_sources],  SourceInfoResponse.mergeDataSource);
        
        if (!options.noSortDataSources)  {
          merged.sources.data_sources = SourceInfoResponse.sortDataSources(merged.sources.data_sources, options);
        }

        merged.sources.constraints = this._mergeObjects([merged.sources.constraints, rhs.sources.constraints],  SourceInfoResponse.mergeConstraint);
      }
      merged.status_messages = Common.StatusMessages.merge(merged.status_messages, rhs.status_messages);
      if (rhs.user_name) merged.user_name = rhs.user_name;
      if (!_.isUndefined(rhs.is_anonymous_user)) merged.is_anonymous_user = rhs.is_anonymous_user;

      return merged;
    },

    update: function (channel, callback) {
      var that = this,
          responseObserver = this._responseObserver = {},
          request = {};

      if (!channel) {
        this.load({
            sources: {
              sources: {},
              constraints: {},
              data_sources: {}
            }
          });
      }

      _.extend(responseObserver, Backbone.Events);
      this._responseObserver.on("response", function (response, channel) {
        var options = {parse: true, merge: true, source_id: channel.get("id")};
        if (that.applyCustomOrder) {
          options.applyCustomOrder = that.applyCustomOrder;
        }
        that.load(response, options);
        if (_.isFunction(callback)) {
          callback(response);
        }
      });
      if (_.isFunction(callback)) {
        this._responseObserver.on("error", function (error) {
          try {
            callback(null, error);
          } catch (e) {
            if (console && console.error) console.error(e, e.stack);
          }
        });
      }

      this.serviceStub.cast(channel || this.channel, request, responseObserver);
    }
  });
  
  var SourceInfoServiceFactory = SourceInfo.ServiceFactory = function() {}
  
  _.extend(SourceInfoServiceFactory.prototype, ServiceFactory.prototype, {
      /*    createInput:  function(attrs,options) { return new SourceInfoInputModel(attrs, options); },*/
    createModel:  function(channel, options) {
      options = options || {};
      options.channel = options.channel || channel;
      options.serviceStub = options.serviceStub || new SourceInfoServiceStub();
      var model = new SourceInfoOutputModel({}, options);
      return model;
    }
  });

  return SourceInfo;
})
;